export const animationVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 50 }
};

export const animationContainerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  position: "relative"
};
